export function setLocalStorage(name, value) {
  if (!window.localStorage) {
    this.$message.error('浏览器不支持localstorage');
    return false;
  }
  const storage = window.localStorage;
  return storage.setItem(name, value);
}

export function getLocalStorage(name) {
  if (!window.localStorage) {
    this.$message.error('浏览器不支持localstorage');
    return false;
  }
  const storage = window.localStorage;
  return storage.getItem(name);
}

// 时间戳转换
export function formatData(time, form = 'Y-M-D') {
  if (!time) {
    return '';
  }
  let fomat = form;
  const timeStamp = new Date(Date.parse(time));
  const year = timeStamp.getFullYear(); // 年
  const month = timeStamp.getMonth() + 1 < 10 ?
    `0${timeStamp.getMonth() + 1}` : timeStamp.getMonth() + 1; // 月
  const date = timeStamp.getDate() < 10 ?
    `0${timeStamp.getDate()}` : timeStamp.getDate(); // 日
  const hour = timeStamp.getHours() < 10 ?
    `0${timeStamp.getHours()}` : timeStamp.getHours(); // 时
  const minute = timeStamp.getMinutes() < 10 ?
    `0${timeStamp.getMinutes()}` : timeStamp.getMinutes(); // 分
  const second = timeStamp.getSeconds() < 10 ?
    `0${timeStamp.getSeconds()}` : timeStamp.getSeconds(); // 秒
  if (form.indexOf('Y') >= 0) {
    fomat = fomat.replace('Y', year);
  }
  if (form.indexOf('M') >= 0) {
    fomat = fomat.replace('M', month);
  }
  if (form.indexOf('D') >= 0) {
    fomat = fomat.replace('D', date);
  }
  if (form.indexOf('hh') >= 0) {
    fomat = fomat.replace('hh', hour);
  }
  if (form.indexOf('mm') >= 0) {
    fomat = fomat.replace('mm', minute);
  }
  if (form.indexOf('ss') >= 0) {
    fomat = fomat.replace('ss', second);
  }
  return fomat;
}

export function accMul(arg1, arg2) {
  const arg1Str = arg1.toString();
  const arg2Str = arg2.toString();
  let m = 0;
  const arg1StrFloat = arg1Str.split('.')[1] ? arg1Str.split('.')[1] : '';
  const arg2StrFloat = arg2Str.split('.')[1] ? arg2Str.split('.')[1] : '';
  m = arg1StrFloat.length > arg2StrFloat.length ? arg1StrFloat.length : arg2StrFloat.length;
  const transferResult = (arg1Str.replace('.', '')) * (arg2Str.replace('.', ''));
  /* eslint-disable */
  return transferResult / Math.pow(10, m);
  /* eslint-enable */
}

// 转化是否
export function formatChoose(choose) {
  switch (choose) {
    case 'Y': return '是';
    case 'N': return '否';
    default: return '';
  }
}

// 转化单位
export function formatUnit(number, unit) {
  switch (unit) {
    case 'year': return `${number}年`;
    case 'age': return `保至${number}岁`;
    case 'day': return `保${number}天`;
    case 'month': return `保${number}月`;
    case 'life': return '保终生';
    default: return '';
  }
}

// 转化状态
export function formatStatus(status) {
  switch (status) {
    case 'draft': return '核保失败';
    case 'waiting_health_exam': return '待体检';
    case 'health_exam_failed': return '未通过';
    case 'waiting_pay': return '待支付';
    case 'cancel': return '取消';
    case 'normal': return '正常';
    case 'refunded': return '取消';
    default: return '未知';
  }
}

// 转化保单状态
export function formatPolicyStatus(status) {
  switch (status) {
    case 'none': return '未出';
    case 'issuing': return '出单中';
    case 'issuing_failed': return '出单失败';
    case 'normal': return '正常';
    case 'cancel_in_hesitation_dyas': return '犹豫期退保';
    case 'terminated': return '已终止';
    default: return '未知';
  }
}

// 转化性别
export function formatSex(sex) {
  switch (sex) {
    case 'M': return '男';
    case 'F': return '女';
    default: return '';
  }
}

// 转化证件
export function formatCertType(certType) {
  switch (certType) {
    case 'id_card': return '身份证';
    case 'birth_cert': return '出生证';
    default: return '';
  }
}

// 转化数组大写
export function formatNumber(number) {
  switch (number) {
    case 1: return '一';
    case 2: return '二';
    case 3: return '三';
    case 4: return '四';
    case 5: return '五';
    case 6: return '六';
    case 7: return '七';
    case 8: return '八';
    case 9: return '九';
    case 10: return '十';
    default: return '';
  }
}

// 转化关系
export function formatRelationship(relationship) {
  switch (relationship) {
    case 'self': return '本人';
    case 'parents': return '父母';
    case 'couple': return '配偶';
    case 'children': return '子女';
    default: return '';
  }
}

// 转化收入来源
export function formatIncomeOrigin(incomeOrigin) {
  let fomatOrigin = incomeOrigin;
  if (fomatOrigin.indexOf('gz') >= 0) {
    fomatOrigin = fomatOrigin.replace('gz', '工资');
  }
  if (fomatOrigin.indexOf('jj') >= 0) {
    fomatOrigin = fomatOrigin.replace('jj', '奖金');
  }
  if (fomatOrigin.indexOf('tz') >= 0) {
    fomatOrigin = fomatOrigin.replace('tz', '投资');
  }
  return fomatOrigin;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js